export enum TemplateExportTypeEnum {
  UI = 0,
  Background = 1,
}
